$(document).ready(function() {
  var currentPage = 1;
  var hasMoreProducts = true;
  var collectionHandle = $('#load-more-button').data('collectionHandle');

  $('#load-more-button').click(function() {
    // ... (rest of your code)

    $.ajax({
      url: '/collections/' + collectionHandle + '?page=' + currentPage,
      dataType: 'json',
      success: function(data) {
        if (data && data.products && data.products.length > 0) {
          // Process and append products
          hasMoreProducts = true;
        } else {
          hasMoreProducts = false;
          $('#load-more-button').text('No More Products').addClass('disabled');
        }
      },
      error: function(error) {
        console.error('Error loading products:', error);
        // Handle error gracefully, e.g., show an error message
      }
    });
  });
});
